import { Locale, SubtitleTextSizes } from '../typings';

export const es_US: Locale = {
  name: 'es_US',
  translations: {
    General: {
      On: 'Activado',
      Off: 'Desactivado',
    },
    BottomControls: {
      NowPlaying: 'Reproducción en curso',
      PlayingOn: (device: string) => `Reproduciendo en ${device}`,
    },
    ContextMenuOverlay: {
      Version: (version: string) => `Version: ${version}`,
      PoweredByBeachbody: 'Con tecnología de Beachbody',
    },
    ErrorOverlay: {
      ErrorCode: (code: number) => `Error ${code}`,
      CannotBePlayed: 'No es posible reproducir este video.',
      PleaseTryAgain: 'Inténtalo de nuevo más tarde.',
    },
    LanguageOptions: {
      Subtitles: 'Subtítulos',
      SubtitleOptions: 'Opciones de subtítulos',
      Audio: 'Audio',
    },
    SubtitleOptions: {
      FontSize: 'Tamaño de letra',
      TextSizeOption: textSize => {
        switch (textSize) {
          case SubtitleTextSizes.Smallest:
            return 'Más pequeño';
          case SubtitleTextSizes.Small:
            return 'Pequeño';
          case SubtitleTextSizes.Normal:
            return 'Normal';
          case SubtitleTextSizes.Large:
            return 'Grande';
          case SubtitleTextSizes.Largest:
            return 'Más grande';
          default:
            return 'Normal';
        }
      },
      FontColor: 'Color de letra',
      BoldText: 'Texto en negrita',
    },
    ModifierIndicator: {
      Modifier: 'Modificador',
    },
    ResumeOverlay: {
      AboutToPlay: 'A punto de reproducir',
      ResumeVideo: 'Reanudar el video',
      StartOver: 'Comenzar de nuevo',
    },
  },
};
